export default "__VITE_ASSET__D5lYSn6k__"